export default __webpack_public_path__ + "static/media/apollo_3.f84ed554.jpg";